import { Configuration, LogLevel } from "@azure/msal-browser";
import { AuthProvider } from "../types/user.types";

// Re-export AuthProvider for convenience
export { AuthProvider };

// MSAL configuration for Entra ID Internal tenant (Admins/Managers)
export const msalInternalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_INTERNAL_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ENTRA_INTERNAL_TENANT_ID}`,
    redirectUri: `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    navigateToLoginRequestUrl: false, // We handle navigation ourselves after processing the token
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// MSAL configuration for Entra External ID tenant (Reviewers)
export const msalExternalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_EXTERNAL_CLIENT_ID || "",
    authority: `https://${process.env.REACT_APP_ENTRA_EXTERNAL_TENANT}.ciamlogin.com/${process.env.REACT_APP_ENTRA_EXTERNAL_TENANT_ID}`,
    redirectUri: `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    navigateToLoginRequestUrl: false, // We handle navigation ourselves after processing the token
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Scopes for authentication
export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
